module.exports = __webpack_public_path__ + "static/media/023.604abb5a.jpg";